import ModalFilterEditor from './FilterByParameters/ModalFilterEditor';
import HumanFriendlyRuleWithActions from './FilterByParameters/HumanFriendlyRuleWithActions';
import SelectedArea from './FilterByParameters/SelectedArea';
import { ModalCollection } from './SelectCollection/ModalCollection';

// @ts-ignore
import { _ } from '../Lang.class.js';

import Filter from './FilterByParameters/Filter';
import { FilterManager } from './FilterByParameters/FilterManager';

import './FilterGroup.scss';
import FilterLastUsed from './FilterByParameters/FilterLastUsed';
import { AndOrSelectIndicator } from './FilterByParameters/AndOrSelectIndicator';

interface CollectionType {
    id: string;
    name: string;
    dbname: string;
    color?: string;
}

interface FilterGroupCallbacks {
    onChangeFilter: (filter: Filter, filterLastUsed: FilterLastUsed, reloadGroup: boolean) => void;
    onLoadView: () => void;
    onSaveView: () => void;
}

class ObjectCounterElement {
    // private div: HTMLDivElement;
    private root: HTMLDivElement | null = null;
    private version: number = 3;

    setRoot(root: HTMLDivElement, version: number) {
        this.root = root;
        this.version = version;
    }

    public update(objectCounter: number, objectTotalCounter: number): boolean {
        if (isNaN(objectCounter) || isNaN(objectTotalCounter)) {
            console.warn(
                'ObjectCounterElement, update, objectCounter or objectTotalCounter is NaN: ',
                objectCounter,
                objectTotalCounter
            );
            return false;
        }
        switch (this.version) {
            case 1:
                this.root.innerHTML = `
                    <div>(<span class="filter-object-counter">${objectCounter}</span>/<span class="filter-object-total-counter">${objectTotalCounter}</span>)</div>
                `;
                break;
            case 2:
                this.root.innerHTML =
                    `
            ` +
                    (objectCounter !== objectTotalCounter
                        ? `
                <span class="filter-object-counter">${objectCounter}</span>
                <span class="filter-object-counter-separator">/</span>
                `
                        : '') +
                    `
                <span class="filter-object-total-counter">${objectTotalCounter}</span>
            `;
                break;
            case 3:
                this.root.innerHTML = `
                    <span class="filter-object-counter">(${objectCounter})</span>
                `;
                break;
        }
        return true;
    }
}

class FilterGroup {
    private readonly root: HTMLElement;
    private readonly mainRoot: HTMLDivElement;
    private readonly szumDrawer: any;
    private readonly filter: Filter;
    private readonly filterLastUsed: FilterLastUsed;
    private filterManager: FilterManager;
    private callbacks: FilterGroupCallbacks;
    private modalFilterEditor: ModalFilterEditor | null = null;
    private objectCounter: number;
    private objectTotalCounter: number;
    private readonly filterRelativeTargetRect: HTMLElement;
    private readonly filterDialogContainer: HTMLDivElement;
    private readonly selectCollection: ModalCollection;
    private currentCollection: CollectionType | null = null;
    private readonly showViewButtons: boolean;
    private objectCounterElement: ObjectCounterElement;
    private showButtonRemoveAll: boolean = true;
    private showButtonRestoreFilter: boolean = true;

    constructor(
        mainRoot: HTMLDivElement,
        root: HTMLElement,
        szumDrawer: any,
        filterManager: FilterManager,
        filterRelativeTargetRect: HTMLElement,
        selectCollection: ModalCollection,
        showViewButtons: boolean,
        showButtonRemoveAll: boolean,
        showButtonRestoreFilter: boolean,
        callbacks: FilterGroupCallbacks
    ) {
        // this.root = document.querySelector(root_selector) as HTMLElement;
        this.mainRoot = mainRoot;
        this.root = root;
        this.szumDrawer = szumDrawer;
        this.callbacks = callbacks;
        this.filterManager = filterManager;
        this.filter = this.filterManager.getMainFilter();
        this.filterLastUsed = this.filterManager.getLastUsedFilter();
        this.objectCounter = 0;
        this.objectTotalCounter = 0;
        this.filterRelativeTargetRect = filterRelativeTargetRect;

        // <div id="filter_dialog_container" class="elements_filter_list" style = "" > </div>
        this.filterDialogContainer = document.createElement('div') as HTMLDivElement;
        this.filterDialogContainer.id = 'filter_dialog_container';
        this.filterDialogContainer.classList.add('elements_filter_list');
        this.filterDialogContainer.style.display = 'none'; // FIXME:
        this.mainRoot.querySelector('.geocoding-app').appendChild(this.filterDialogContainer);

        this.selectCollection = selectCollection;
        this.currentCollection = null;

        this.showViewButtons = showViewButtons;
        this.showButtonRemoveAll = showButtonRemoveAll;
        this.showButtonRestoreFilter = showButtonRestoreFilter;
        this.objectCounterElement = new ObjectCounterElement();

        this.reload();
    }

    setCurrentCollection(collection: CollectionType) {
        // NOT USED ??
        this.currentCollection = collection;
    }

    setObjectCounter(count: number, totalCount: number) {
        if (isNaN(count) || isNaN(totalCount)) {
            console.warn(
                'FilterGroup, setObjectCounter, count or totalCount is NaN: ',
                count,
                totalCount
            );
            return;
        }
        this.objectCounter = count;
        this.objectTotalCounter = totalCount;
        this.objectCounterElement.update(this.objectCounter, this.objectTotalCounter);
    }

    disable() {
        let el = this.root.querySelector('.filter_group') as HTMLDivElement;
        let loader = this.root.querySelector('.filter_reloading') as HTMLDivElement;
        if (el) {
            el.style.display = 'none';
            loader.style.display = 'flex';
        }
    }

    enable() {
        let el = this.root.querySelector('.filter_group') as HTMLDivElement;
        let loader = this.root.querySelector('.filter_reloading') as HTMLDivElement;
        if (el) {
            el.style.display = 'flex';
            loader.style.display = 'none';
        }
    }

    reload() {
        if (!this.root) {
            console.warn('FilterGroup, reload, no root: ', this.root);
            return;
        }
        this.root.innerHTML = this.getHTML();
        try {
            this.szumDrawer.getMap().updateSize();
        } catch (e) {
            console.error('FilterGroup, reload, no map: ', e.message);
        }
        this.disable();

        if (this.filterDialogContainer) {
            this.modalFilterEditor = new ModalFilterEditor(
                this.filterDialogContainer,
                this.filter,
                this.filterLastUsed,
                this.szumDrawer,
                this.filterRelativeTargetRect,
                this.showViewButtons, // Define to show ViewSave and ViewLoad buttons
                {
                    onSave: (filter: Filter, filterLastUsed: Filter) => {
                        console.log(
                            'onSave (FilterGroup)',
                            filter.getFilterQueries(),
                            filterLastUsed.getFilterQueries(),
                            this.filter.andOrSelection
                        );
                        this.filter.andOrSelection = filter.andOrSelection;
                        this.filter.setFilterQueries(filter.getFilterQueries());
                        this.filter.setFilterRelated(filter.getFilterRelated());
                        this.filterLastUsed.setFilterQueries(filterLastUsed.getFilterQueries());
                        this.filterLastUsed.setFilterRelated(filterLastUsed.getFilterRelated());
                        this.callbacks.onChangeFilter(this.filter, this.filterLastUsed, true);
                        this.root.style.pointerEvents = '';
                        // this.reload();
                    },
                    onCancel: () => {
                        console.log('onCancel (FilterGroup)');
                        this.root.style.pointerEvents = '';
                    },
                    onLoadView: this.callbacks.onLoadView,
                    onSaveView: this.callbacks.onSaveView,
                    onTemporaryHide: () => {
                        this.root.style.pointerEvents = 'none';
                        // console.log('onTemporaryHide (FilterGroup)', this.root);
                    },
                    onHide: () => {
                        // console.log('onHide (FilterGroup)', this.root);
                        this.root.style.pointerEvents = '';
                    },
                }
            );
        }

        // let addFilterText = this.root.querySelector(
        //     '.telematics-filter_bar_more__add span'
        // ) as HTMLSpanElement;
        // if (addFilterText) {
        let filterButtonFull = this.root.querySelector('.js-add-filter-full') as HTMLDivElement;
        let filterButtonSimple = this.root.querySelector('.js-add-filter-simple') as HTMLDivElement;

        if (Object.keys(this.filter.getFilterQueries()).length > 0) {
            filterButtonFull.style.display = 'none';
            filterButtonSimple.style.display = 'flex';
        } else {
            filterButtonFull.style.display = 'flex';
            filterButtonSimple.style.display = 'none';
        }
        // }

        let el_add_filter = this.root.querySelector('.js-add-filter') as HTMLButtonElement;
        if (el_add_filter) {
            el_add_filter.addEventListener('click', () => {
                if (this.modalFilterEditor !== null) {
                    this.modalFilterEditor.setFilter(this.filter.getFilterQueries());
                    this.modalFilterEditor.setSelectedRule(null);
                    this.modalFilterEditor.reload();
                    this.modalFilterEditor.show(
                        document.querySelector('.js-add-filter') as HTMLElement
                    );
                } else {
                    throw new Error('FilterGroup, reload, this.modalFilterEditor is null');
                }
            });
        }

        let el_remove_filter = this.root.querySelector('.js-remove-filter') as HTMLButtonElement;
        if (el_remove_filter) {
            // Clear filter
            el_remove_filter.addEventListener('click', () => {
                Object.keys(this.filter.getFilterQueries()).forEach(key => {
                    this.filterLastUsed.updateFilterItem(key, this.filter.getFilterItem(key));
                });

                this.filterManager
                    .getFeatureRestoreLastRemovedFilter()
                    .setLastRemovedFilter(
                        this.filter.getFilterQueries(),
                        this.filter.getFilterRelated()
                    );
                this.filter.setFilterQueries({});
                this.filter.setFilterRelated([]);
                SelectedArea.resetGeometry();
                this.callbacks.onChangeFilter(this.filter, this.filterLastUsed, true);
            });
        }

        let el_restore_filter = this.root.querySelector('.js-restore-filter') as HTMLDivElement;
        if (el_restore_filter) {
            if (
                this.filter.isEmpty() &&
                !this.filterManager.getFeatureRestoreLastRemovedFilter().isEmpty() &&
                this.showButtonRestoreFilter
            ) {
                el_restore_filter.style.display = 'block';
            } else {
                el_restore_filter.style.display = 'none';
            }
            el_restore_filter.addEventListener('click', () => {
                console.log('onRestoreRemovedFilter');
                let { queries, related } = this.filterManager
                    .getFeatureRestoreLastRemovedFilter()
                    .getLastRemovedFilter();
                this.filter.setFilterQueries(queries);
                this.filter.setFilterRelated(related);
                this.callbacks.onChangeFilter(this.filter, this.filterLastUsed, true);
            });
        }

        let el_collection_selector = this.root.querySelector(
            '.js-collection-selector'
        ) as HTMLSelectElement;
        if (el_collection_selector) {
            el_collection_selector.innerHTML = this.selectCollection.getDescription();
            el_collection_selector.classList.add('modal-collection-description');
            el_collection_selector.addEventListener('click', () => {
                this.selectCollection.show();
            });
        }

        this.filter.getFilterHumanReadableAsArray(this.filterManager).forEach((item, index) => {
            console.log('allAvailableItems getFilterHumanReadableAsArray', item);
            let el_filter_description = this.root.querySelector(
                '.filter-description'
            ) as HTMLDivElement;
            if (el_filter_description) {
                switch (this.filter.andOrSelection) {
                    case 'and':
                        el_filter_description.classList.add('and');
                        break;
                    case 'or':
                        el_filter_description.classList.add('or');
                        break;
                }

                if (
                    index === 1 &&
                    this.filter.andOrSelection !== 'and' &&
                    this.filter.andOrSelectionEnabled
                ) {
                    // by default dont show AND selector
                    el_filter_description.appendChild(AndOrSelectIndicator(this.filter).element);
                }
                el_filter_description.appendChild(
                    HumanFriendlyRuleWithActions(item, {
                        onEdit: (ruleKey, descriptionDOMElement) => {
                            if (this.modalFilterEditor !== null) {
                                if (ruleKey == 'geom') {
                                    ruleKey +=
                                        this.filter.getFilterItem(ruleKey)?.['properties']
                                            ?.filter == 'radius'
                                            ? '/radius'
                                            : '/area';
                                }
                                // console.log('onEdit', ruleKey);
                                this.modalFilterEditor.setFilter(this.filter.getFilterQueries());
                                this.modalFilterEditor.setSelectedRule(ruleKey);
                                this.modalFilterEditor.reload();
                                this.modalFilterEditor.show(descriptionDOMElement, true);
                            } else {
                                throw new Error(
                                    'FilterGroup, reload, this.modalFilterEditor is null'
                                );
                            }
                        },
                        onRemove: ruleKey => {
                            console.log('onRemove', ruleKey);

                            // Add removed rule to last used filter
                            // FIXME: add support for geom/radius
                            // this.filterLastUsed.updateFilterItem(ruleKey, this.filter.getFilterItem(ruleKey));

                            // Remove rule from current filter
                            this.filter.removeFilterItem(ruleKey.split('/')[0]);
                            if (ruleKey.split('/')[0] === 'geom') {
                                SelectedArea.resetGeometry();
                            }

                            this.filterManager.getFeatureRestoreLastRemovedFilter().clear();
                            // this.filterManager.featureInactiveQueries.removeKeyFromInactiveQueries(ruleKey);

                            this.callbacks.onChangeFilter(this.filter, this.filterLastUsed, true);
                        },
                        onChangeSelect: (ruleKey, selectedIds, reloadGroup: boolean) => {
                            if (selectedIds.length === 0) {
                                console.log('Removing filter due to empty selectedIds');
                                this.filter.removeFilterItem(ruleKey);
                            } else {
                                this.filter.updateSelectedValues(ruleKey, selectedIds);
                            }
                            this.callbacks.onChangeFilter(
                                this.filter,
                                this.filterLastUsed,
                                reloadGroup
                            );
                        },
                        onToggleActive: (ruleKey, active) => {
                            // this.filter.updateActive(ruleKey, active);
                            this.filterManager.featureInactiveQueries.setActiveQuery(
                                ruleKey,
                                active
                            );
                            this.callbacks.onChangeFilter(this.filter, this.filterLastUsed, false);
                        },
                    })
                );
            }
        });

        if (el_remove_filter) {
            if (this.filter.getCountFilterRules() === 0 || !this.showButtonRemoveAll) {
                el_remove_filter.style.display = 'none';
            } else {
                el_remove_filter.style.display = 'block';
            }
        }

        let el_object_counter = this.root.querySelector('.js-object-counter') as HTMLDivElement;
        if (el_object_counter) {
            this.objectCounterElement.setRoot(el_object_counter, 3);
            this.objectCounterElement.update(this.objectCounter, this.objectTotalCounter);
        } else {
            throw new Error('FilterGroup, reload, el_object_counter is null');
        }

        this.enable();
    }

    getHTML() {
        return `
        <div class="telematics-filter_group">
            <span class="js-collection-selector"></span>
            <div class="js-object-counter" style="margin-left: 10px;"></div>
            <span class="filter-description" style="display: contents; "></span>
            <div style="display: flex; align-items: center; column-gap: 8px;">
                <div class="js-add-filter" style="display: flex; align-items: center; column-gap: 8px;" title="${_('Add filter')}">
                    <div style="display: flex; align-items: center;" class="telematics-filter_bar_more js-add-filter-full telematics-filter_bar_more__empty">
<!--                      <div title="" style="width:21px; height:21px; " class="icon s-Hx8jruu2YYnm"><img src="/src/assets/official/FilterS.svg" alt="Filtr" style="width:21px; height:21px; " class="s-Hx8jruu2YYnm"></div>-->
                      <div class="telematics-filter_icon_filter"></div>
                      <div class="telematics-filter_icon_add"></div>
                      <span style="padding-left: 0;">${_('Add filter')}</span>
                    </div>
                    <div class="telematics-filter_bar_more js-add-filter-simple telematics-filter_bar_more__add"></div>
                </div>
                <span class="telematics-filter_bar_more js-remove-filter telematics-filter_bar_more__remove" title="${_('Remove filters')}"></span>
                <div class="telematics-filter_bar_more js-restore-filter telematics-filter_bar_more__restore" title="${_('Restore filters')}">
                    <span>${_('Restore filters')}</span>
                </div>
            </div>
            <!--
            <div style="display: flex; align-items: center; column-gap: 8px;">
                <div title="" style="width:21px; height:21px; " class="icon s-Hx8jruu2YYnm"><img src="/src/assets/official/FilterS.svg" alt="Filtr" style="width:21px; height:21px; " class="s-Hx8jruu2YYnm"></div>
                <div class="telematics-filter_bar_more js-add-filter telematics-filter_bar_more__add" title="${_('Add filter')}"><span style="padding-left: 6px;">${_('Add filter')}</span></div>
                <span class="telematics-filter_bar_more js-remove-filter telematics-filter_bar_more__remove" title="${_('Remove filters')}"></span>
                <div class="telematics-filter_bar_more js-restore-filter telematics-filter_bar_more__restore" title="${_('Restore filters')}">
                    <span>${_('Restore filters')}</span>
                </div>
            </div>
            !-->
        </div>
        <div class="telematics-filter_reloading" style="display: none;">
            ${_('Reloading')}...
        </div>
            `;
    }
}

export default FilterGroup;
